import { Car, CarFront, Truck } from "lucide-react";
import { VT_LABELS } from "./TicketBits";

const VT_ICONS = { auto: Car, furgone: CarFront, camion: Truck };

export const ExpertCard = ({ expert, testid }) => {
  const initials = expert.name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
  return (
    <article
      data-testid={testid}
      className="glass-card rounded-2xl p-6 flex flex-col hover:-translate-y-1 transition-transform duration-200"
    >
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-full bg-volt/15 border border-volt/30 flex items-center justify-center font-display font-bold text-volt">
          {initials}
        </div>
        <div className="min-w-0">
          <h3 className="font-display font-semibold text-white truncate">{expert.name}</h3>
          <p className="font-mono text-[10px] uppercase tracking-wider text-slate-500">
            {expert.completed || 0} consulenze completate
          </p>
        </div>
      </div>
      {expert.bio && <p className="mt-4 text-sm text-slate-400 leading-relaxed line-clamp-3">{expert.bio}</p>}
      <div className="mt-4 flex flex-wrap gap-1.5">
        {(expert.specializations || []).map((s) => (
          <span key={s} className="font-mono text-[10px] uppercase tracking-wider border border-volt/25 text-volt rounded-full px-2.5 py-1">
            {s}
          </span>
        ))}
      </div>
      <div className="mt-3 flex items-center gap-3 text-slate-500">
        {(expert.vehicle_types || []).map((v) => {
          const Icon = VT_ICONS[v];
          return Icon ? (
            <span key={v} className="flex items-center gap-1.5 text-xs">
              <Icon size={14} className="text-spark" /> {VT_LABELS[v]}
            </span>
          ) : null;
        })}
      </div>
    </article>
  );
};
